import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-saved-search',
  templateUrl: './saved-search.component.html',
})
export class SavedSearchComponent implements OnInit {
  selectedSaveSearch: string = null;
  isRunSearch: boolean = false;
  @Input() searchList: any;
  @Input() isFromAppointment: any;

  @Output() onReset = new EventEmitter<any>();
  @Output() onEditOrRun = new EventEmitter<any>();
  @Output() onDelete = new EventEmitter<any>();

  constructor(private activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    this.selectedSaveSearch = null;
  }

  onRun = (data) => this.onEditOrRun.emit({ searchData: data, isRun: true });

  onEditOrApply = () => {
    this.isRunSearch = false;
    this.onEditOrRun.emit({
      searchData: this.selectedSaveSearch,
      isRun: false,
    });
    this.onClose();
};
  onDeleteClick = (data) => this.onDelete.emit(data);
  onResetClick = () => this.onReset.emit();
  onClose = () => this.activeModal.dismiss();
  
}
